module.exports = __webpack_public_path__ + "static/img/3_marimissimo.d60631f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enemies/3_marimissimo.png
// module id = k2pU
// module chunks = 1